<style lang="scss">
@import './index.scss';
</style>
<template>
  <div class="set-funnel">
        <div class="set-funnel-title">
            <h1 class="set-funnel-title-h3"><a @click="isCertainLeave">{{ $t('funnel.title') }}</a> > {{ $t('funnel.setfunnel') }}</h1>
        </div>
        <div class="set-funnel-view">
            <Row class="set-funnel-view-row">
                <i-col class="set-funnel-view-row-title" :sm="3" :lg="2">{{ $t('funnel.funnelname') }}</i-col>
                <i-col span="8"><i-input v-model="funnelName" @on-blur="testingFunnelName" :placeholder="$t('common.input')"></i-input></i-col>
                <i-col span="8" v-if="submitNullName" class="set-funnel-view-row-info"><span>{{ $t('funnel.funnelname') }}</span> <span>{{ $t('funnel.null') }}</span></i-col>
            </Row>
            <p class="set-funnel-view-info">{{ $t('funnel.funnelInfo') }}</p>
            <i-form class="set-funnel-view-iform" ref="formDynamic" :model="formDynamic" :label-width="80">
                <Form-item
                    class="set-funnel-view-iform-item"
                    v-for="(item, index) in formDynamic.items"
                    :label="$t('funnel.step') + (index + 1)"
                    :key="index">
                    <Row>
                        <i-col span="11">
                            <Form-item
                                :label="$t('funnel.analysis')"
                                :prop="'items.' + index + '.value'"
                                :rules="{required: true, message: $t('funnel.event') + $t('funnel.null'), trigger: 'change'}">
                                <i-select
                                    v-model="item.value"
                                    :placeholder="$t('funnel.placeholder')"
                                    @on-change="setItemName"
                                    label-in-value
                                    filterable>
                                    <i-option
                                      class="textEllipsis"
                                      :title="name.displayname || name.eventid"
                                      v-for="(name, index) in namelist"
                                      :value="name.eventid"
                                      :key="index"
                                      :label="name.displayname || name.eventid"
                                      >
                                        <i
                                          v-for="eachPlat in name.platformIds"
                                          :key="eachPlat"
                                          :class="['event-icon', 'iconfont', platformInfo[eachPlat].icon]">
                                        </i>
                                        {{ name.displayname || name.eventid }}
                                        <i v-if="name.eventType"
                                          class="ivu-icon ivu-icon-md-document"
                                          style="float: right; color: #a5a3a3"></i>
                                    </i-option>
                                </i-select>
                            </Form-item>
                            <span style='color:#FF6600'>{{ item.info }}</span>
                        </i-col>
                        <i-col span="11">
                            <Form-item
                                :label="$t('funnel.stepname')"
                                :prop="'items.' + index + '.name'"
                                :rules="{required: false, message: $t('funnel.name') + $t('funnel.null'), trigger: 'blur'}">
                                <i-input type="text" v-model="item.name" :placeholder="$t('funnel.stepname')"></i-input>
                            </Form-item>
                        </i-col>
                        <i-col span="1" offset="1">
                            <Icon type="md-remove-circle" class="set-funnel-view-close" @click.native="handleRemove(item)" size='16'></Icon>
                        </i-col>
                    </Row>
                </Form-item>
                <Form-item class="set-funnel-view-iform-btn">
                    <i-button type="primary" shape="circle" @click="handleAdd" :disabled="addStepDisable">{{ $t('funnel.addStep') }}</i-button>
                </Form-item>
                <Form-item class="set-funnel-view-iform-set">
                    <i-button type="primary" style="width:20%;" @click="handleSubmit('formDynamic')">{{ $t('common.save') }}</i-button>
                    <i-button type="text" @click="handleReset('formDynamic')" style="margin-left: 8px">{{ $t('filter.clear') }}</i-button>
                </Form-item>
            </i-form>
        </div>
        <!-- 通用询问窗口，当前页处于设置页面，跳转其他页面时的提示 -->
        <Modal
            v-model="discardChangeShow"
            :mask-closable="false"
            @on-ok="discardChange"
        >
            {{ $t('common.noSave') }} <br/>
            {{ $t('common.isLeave') }}
        </Modal>
  </div>
</template>
<script>
import $ from '../../libs/util';
import bus from '../../libs/bus';
import ln from '../../libs/locale';

export default {
  props: {},
  data() {
    return {
      funnelName: '',
      formDynamic: {
        items: [{
          value: '', // eventid
          name: '', // step name
          label: '', // the same as name
          type: 0, // 支持标准事件
        }],
      },
      linkUrl: `/analytics/behavior/funnel/${bus.productInfo.productid}`,
      update: false,
      namelist: [],
      selectChange: [],
      submitNullName: false,
      discardChangeShow: false,
      platformInfo: {
        1: {
          value: 1,
          name: 'android',
          icon: 'icon-android-r',
        },
        2: {
          value: 2,
          name: 'ios',
          icon: 'icon-iOS-r',
        },
        4: {
          value: 4,
          name: 'windows',
          icon: 'icon-windows-r',
        },
        16: {
          value: 16,
          name: 'html5',
          icon: 'icon-html-r',
        },
        32: {
          value: 32,
          name: 'weichat',
          icon: 'icon-miniprogram-r',
        },
        64: {
          value: 64,
          name: 'quickapp',
          icon: 'icon-kuaiyingyongSDK',
        },
      },
    };
  },
  components: {
  },
  computed: {
    addStepDisable() {
      return this.formDynamic.items.length >= 8;
    },
  },
  created() {
    const self = this;
    self.getAllEvent();
    if (bus.setFunnel) {
      self.funnelName = bus.setFunnel.name;
      self.update = true;
    }
  },
  mounted() {
    const self = this;
    bus.$on('on-app-change', () => {
      self.$router.push({
        path: `/analytics/behavior/funnel/${bus.productInfo.productid}`,
      });
    });
    bus.$on('on-platform-change', () => {
      self.handleReset('formDynamic');
      self.getAllEvent();
    });
    bus.$on('on-conditions-change', () => {
      self.handleReset('formDynamic');
      self.getAllEvent();
    });
  },
  beforeDestroy() {
    bus.$off('on-app-change');
    bus.setFunnel = undefined;
    this.funnelName = '';
    this.formDynamic = {
      items: [{
        value: '',
        name: '',
        label: '',
      }],
    };
    this.update = false;
    this.namelist = [];
  },
  methods: {
    // 点击title跳转
    isCertainLeave() {
      this.discardChangeShow = true;
    },
    discardChange() {
      this.$router.push({
        path: this.linkUrl,
      });
    },
    // 检测名称是否为空
    testingFunnelName() {
      if (this.funnelName === '') {
        this.submitNullName = true;
      } else {
        this.submitNullName = false;
      }
    },
    // 获取所有事件
    getAllEvent() {
      const params = {
        platformid: bus.platform.toString(),
        productid: bus.productInfo.productid,
      };
      $.ajax.get('app/rest/eventManager/getEventList', { params }).then((res) => {
        // 所有事件对象列表，支持标准事件和自定义事件
        this.namelist = res.map((eachevent) => {
          const tempevent = eachevent;
          // 标准事件的eventid是int型,转为string型
          if (typeof tempevent.eventid === 'number') {
            tempevent.eventid = tempevent.eventid.toString();
          }
          return tempevent;
        });
        const list = res.map(x => x.eventid); // 所有事件ID列表，支持标准事件和自定义事件
        // 如果是编辑漏斗，渲染现有步骤
        if (bus.setFunnel) {
          this.formDynamic.items = this.reloadData(list);
        }
      });
    },
    // 提交判断
    handleSubmit(name) {
      /*
      ** demo环境下不允许增删改
      **/
      if (this.formDynamic.items.length > 8) {
        this.$Message.destroy();
        this.$Message.warning({
          content: '最多支持8个步骤',
        });
        return;
      }
      if (bus.demoTip()) return;
      if (this.funnelName === '') {
        this.submitNullName = true;
      } else if (this.formDynamic.items.length < 2) {
        this.$Message.success({
          content: this.$t('funnel.noLess'),
          duration: 3,
        });
      } else {
        this.$refs[name].validate((valid) => {
          // const items = this.formDynamic.items;
          if (valid) {
            // 构建请求体
            let stepName = [];
            const funnelInfo = this.formDynamic.items.map((item) => {
              const nameTemp = this.getStepName(item.name, item.value);
              stepName.push(nameTemp);
              return {
                eventid: item.value,
                stepname: nameTemp,
                eventtype: item.type,
              };
            });
            // 转化漏斗步骤名称不可重复
            stepName = stepName.sort();
            for (let i = 0; i < stepName.length; i++) {
              if (stepName[i] === stepName[i + 1]) {
                this.$Message.destroy();
                this.$Message.error({
                  content: this.$t('funnel.repeatStepName'),
                  duration: 3,
                });
                return;
              }
            }
            const params = {
              developerid: bus.developerid,
              productid: bus.productInfo.productid,
              id: this.update ? bus.setFunnel.id : undefined,
              name: this.funnelName,
              info: JSON.stringify(funnelInfo),
            };
            if (this.update) { // 修改
              $.ajax.post('app/rest/eventFlow.json/updateFlow', params).then(() => {
                this.$Message.success({
                  content: this.$t('funnel.update'),
                  duration: 3,
                });
                return this.$router.push({
                  path: `/analytics/behavior/funnel/${bus.productInfo.productid}`,
                });
              });
            } else { // 创建
              $.ajax.post('app/rest/eventFlow.json/createFlow', params).then(() => {
                this.$Message.success({
                  content: this.$t('funnel.create'),
                  duration: 3,
                });
                return this.$router.push({
                  path: `/analytics/behavior/funnel/${bus.productInfo.productid}`,
                });
              });
            }
          } else {
            this.$Message.error({
              content: this.$t('common.fail'),
              duration: 3,
            });
          }
        });
      }
    },
    handleReset(name) { // 重置数据
      this[name] = {
        items: [
          {
            value: '',
            name: '',
            label: '',
            type: 0,
          },
        ],
      };
    },
    handleAdd() { // 添加Step
      if (this.formDynamic.items.length >= 8) {
        this.$Message.destroy();
        this.$Message.warning({
          content: '最多支持8个步骤',
        });
        return;
      }
      this.formDynamic.items.push({
        value: '',
        name: '',
        label: '',
        // new property event type
        type: 0,
      });
    },
    handleRemove(item) { // 删除Step
      // this.formDynamic.items.$remove(item);
      const index = this.formDynamic.items.indexOf(item);
      this.formDynamic.items.splice(index, 1);
    },
    // 渲染编辑的数据
    reloadData(list) {
      const info = ln[bus.lang].funnel.eventdelinfo;
      const items = bus.setFunnel.info.map(eachstep => ({
        value: typeof eachstep.eventid === 'number' ?
          eachstep.eventid.toString() : eachstep.eventid,
        name: this.getStepName(eachstep.stepname, eachstep.eventid),
        label: this.getStepName(eachstep.stepname, eachstep.eventid),
        type: eachstep.eventtype,
        info: list.indexOf(eachstep.eventid) === -1 ? info : '',
      }));
      return items;
    },
    // 获取步骤展示名
    getStepName(stepname, eventid) {
      // 如果有stepname属性使用，次级是eventname, 没有使用eventid
      let eventname;
      this.namelist.forEach((eachevent) => {
        if (eachevent.eventid === eventid) {
          eventname = eachevent.displayname ? eachevent.displayname : undefined;
        }
      });
      return stepname || eventname || eventid;
    },
    setItemName(name) {
      for (let i = 0; i < this.formDynamic.items.length; i += 1) {
        const item = this.formDynamic.items[i];
        if (item.value === name.value) {
          item.label = name.label;
          // set item.eventType here
          item.type = this.setEventType(name.value);
        }
      }
    },
    // 通过eventid查询事件类型event type
    setEventType(e) {
      let targetType = 0;
      this.namelist.forEach((eachevent) => {
        if (eachevent.eventid === e) {
          // eventType定义了则为标准事件1，否则为自定义事件
          targetType = eachevent.eventType ? 1 : 0;
        }
      });
      return targetType;
    },
  },
};
</script>
